import { Colors } from '@doordash/design-language'
import styled from 'styled-components'

type RootProps = {
  includeMobileHeader?: boolean
}

export const Root = styled<RootProps, 'div'>('div')`
  height: 100%;
  width: 100%;
  overflow-y: auto;
  background-color: ${Colors.PageBackgroundSecondary};
  padding-top: 70px;

  ${(props: RootProps) =>
    props.includeMobileHeader
      ? `
      @media (max-width: 480px) {
        padding-top: 60px;
        background-color: ${Colors.SystemWhite};
      }
    `
      : `
      @media (max-width: 480px) {
        padding-top: 0;
        background-color: ${Colors.SystemWhite};
      }
    `}
`

Root.defaultProps = {
  includeMobileHeader: true,
}

export default Root
